export const BANGKOK_PROVINCE_CODE = '10';
